import { UserDataService } from 'src/app/DataServices/user-data.service';
import { Component, OnDestroy, OnInit, QueryList, ViewChildren } from '@angular/core';
import { Router } from '@angular/router';
import { ModalDismissReasons, NgbModal, NgbModalConfig } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { CurrentLanguage } from 'projects/Autofacets-Core/src/app/common-services/current-language.service';
import { CustomPaggerService } from 'projects/Autofacets-Core/src/app/common-services/custom-pagger.service';
import { Utility } from 'projects/Autofacets-Core/src/app/utils/utility';
import { NgbdSortableHeader, SortEvent } from 'projects/Autofacets-Core/src/app/directives/sortable.directive';
import { BaseService } from 'projects/Autofacets-Core/src/app/services/base.service';
import { NgbdModalContent } from 'projects/Autofacets-Core/src/app/shared/delete-modal.component';
import { Constant } from 'projects/Autofacets-Core/src/app/utils/constant';
import { BehaviorSubject, Observable, Subscription } from 'rxjs';
import { DiagnoseSubCheckListViewModel, DignoseSubCheckListDetailViewModel } from '../../../business-entities/diagnose-check-list-model';
import { CheckListBusinessService } from '../../../business-services/check-list.service';
import { DiagnoseCheckListBusinessService } from './../../../business-services/diagnose-check-list.service'
import * as fromEnums from 'projects/Autofacets-Core/src/app/utils/enums';
import { UserRoleMenu } from '../../../business-entities/user-role-menu.model';
import { AddDiagnoseCheckListComponent } from './add-diagnose-check-list/add-diagnose-check-list/add-diagnose-check-list.component';
import { AddDiagnoseCheckListItemsComponent } from './add-diagnose-check-list-items/add-diagnose-check-list-items.component';

@Component({
  selector: 'app-diagnose-check-list',
  templateUrl: './diagnose-check-list.component.html',
  styleUrls: ['./diagnose-check-list.component.css']
})
export class DiagnoseCheckListComponent implements OnInit,OnDestroy {
  checkList: DiagnoseSubCheckListViewModel[];
  total$: Observable<number>;
  paginationSub: Subscription
  currentlagSub: Subscription
  language:string
  popupCloseResult = false;
  userRoleRightsDetails: UserRoleMenu;
  @ViewChildren(NgbdSortableHeader) headers: QueryList<NgbdSortableHeader>;
  constructor(
    private diagnoseService: DiagnoseCheckListBusinessService,
    public pService: CustomPaggerService,
    private router: Router,
    private currentLanguageService: CurrentLanguage,
    private spinner: NgxSpinnerService,
    private modalService: NgbModal,
    private baseService: BaseService,
    private toastr: ToastrService,
    private translate: TranslateService,
    private checkListBusinessService: CheckListBusinessService,
    private userService: UserDataService,
    config: NgbModalConfig,
  ) {
    this.pService.pageSize = 10;
    this.pService.searchby = ['subCheckListTitle'];
    this.pService.searchTerm = '';

    config.backdrop = 'static';
    config.keyboard = false;
   }

  onSort({ column, direction }: SortEvent) {
    this.headers.forEach(header => {
      if (header.sortable !== column) {
        header.direction = '';
      }
    });

    this.pService.sortColumn = column;
    this.pService.sortDirection = direction;
  }

  ngOnInit(): void {
    this.userRoleRightsDetails = (this.userService.currentUserValue.userRoleMenuDetails as any[]).find(menu => menu.moduleId === fromEnums.ModuleNames.DiagnoseChecklist);
    this.pService.dataSource = [];
    this.currentlagSub = this.currentLanguageService.currentLanguage.subscribe(x => {
      this.language = x
      this.getDiagnoseCheckList(this.language);
    });
  }

  ngOnDestroy(): void {
    if (this.paginationSub) {
      this.paginationSub.unsubscribe();
    }
    this.currentlagSub.unsubscribe();
    this.pService.dealers$ = new BehaviorSubject<any[]>([]);
    this.pService.total$ = new BehaviorSubject<number>(0);
  }
    async getDiagnoseCheckList(languageCode:string) {
      this.spinner.show();
      await this.diagnoseService.getDiagnoseCheckList(languageCode).then( (res: DignoseSubCheckListDetailViewModel) => {
        this.pService.dataSource = res.dwoSubCheckList;
        this.pService.dealers$.subscribe(result => {
          this.checkList = this.DiagnoseListDataMapper(result);
        });

        this.total$ = this.pService.total$;
        this.spinner.hide();
      });
    }

    private DiagnoseListDataMapper(list: any) {
      let supperArray = [];
      if (list && list.length > 0) {

        for (let index = 0; index < list.length; index++) {
          const element = list[index];

          let single = Object();
          single.rowNumber = this.currentPageNumber(index);
          single.id = element.id;
            single.subCheckListTitle = element.subCheckListTitle;
            single.checkListDescription = element.checkListDescription;
            single.checkListItems = element.checkListItems;
          supperArray.push(single);
        }
      }

      return supperArray;
    }

    private currentPageNumber(cIndex: number): number {
      let rtPageNumber = 0;
      if (this.pService.page === 1) {
        rtPageNumber = cIndex + 1;
      }
      else if (this.pService.page > 1) {
        rtPageNumber = Number.parseInt(`${(this.pService.pageSize * (this.pService.page - 1))}`) + (cIndex + 1);
      }
      return rtPageNumber;
    }
    onAdd() {
      this.diagnoseService.diagnoseId = 0;
      const modalref = this.modalService.open(AddDiagnoseCheckListComponent ,{ size: 'md', windowClass: 'EditPopup' });
      modalref.result.then((response) => {
        if (response.success) {
          this.ngOnInit();
        }
      });
    }
    editCheckList(id:number)
    {
      this.diagnoseService.diagnoseId = id;
      const modalref = this.modalService.open(AddDiagnoseCheckListComponent ,{ size: 'md', windowClass: 'EditPopup' });
      modalref.result.then((response) => {
        if (response.success) {
          this.ngOnInit();
        }
      });
    }
    onAdditem(item: DiagnoseSubCheckListViewModel) {
      this.diagnoseService.Diagnosecheck = item.subCheckListTitle.toString();
      this.diagnoseService.IsAddDiagnoseItems = '1';
      this.diagnoseService.Id = item.id;
      const modalref = this.modalService.open(AddDiagnoseCheckListItemsComponent ,{ size: 'md', windowClass: 'EditPopup' });
      modalref.result.then((response) => {
        if (response.success) {
          this.ngOnInit();
        }
      });
    }
    editCheckListItem(check: any,id:number) {
      this.diagnoseService.Diagnosecheck = check.subCheckListTitle.toString();
      this.diagnoseService.IsAddDiagnoseItems = '0'
      this.diagnoseService.Id = id;
      const modalref = this.modalService.open(AddDiagnoseCheckListItemsComponent ,{ size: 'md', windowClass: 'EditPopup' });
      modalref.result.then((response) => {
        if (response.success) {
          this.ngOnInit();
        }
      });
    }
    deleteCheckList(id: number) {
      let modelHeadermsg = this.translate.instant("lblDelete");
      let modelBodymsg = Utility.createMessage(this.translate.instant("lblSureToDelete"),this.translate.instant("lblCheckList"),false);
      const modalRef = this.modalService.open(NgbdModalContent);
      modalRef.componentInstance.modelHeader = modelHeadermsg;
      modalRef.componentInstance.modelBody = modelBodymsg;
      modalRef.result.then((_result) => {
        // This is intentional
       }, (reason) => {
        this.popupCloseResult = this.getDismissReason(reason);
        if (this.popupCloseResult) {
          let currentUser = this.userService.currentUserValue.userId;
          let deleteRequestModel = { id: id, UserId: currentUser };
          this.checkListBusinessService.deleteCheckList(deleteRequestModel).then((response) => {
            if (response.responseCode == Constant.SuccessResponseCode) {
              let successMsg = this.translate.instant("lblCheckListDeleted");
              this.toastr.success(successMsg);
              this.getDiagnoseCheckList(this.language);
            }
          });
        }
      });
    }

      private getDismissReason(reason: any): boolean {
        if (reason === ModalDismissReasons.ESC) {
          return false;
        } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
          return false;
        } else {
          return reason;
        }
      }
}
